import "./share-channel-picker.css";
import { withStatics } from '../../utils/with-statics';
import { ShareChannelPicker } from './share-channel-picker';
import { shareChannelMap, shareChannelList, shareChannelCollection, normalizeChannels } from './share-channel';
export default withStatics(ShareChannelPicker, {
  Channel: shareChannelMap,
  channelList: shareChannelList,
  channelCollection: shareChannelCollection,
  normalizeChannels: normalizeChannels
});